<template>
  <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="微信支付配置" name="wxpay">
      <wxpayTemplates></wxpayTemplates>
    </el-tab-pane>
    <el-tab-pane label="支付宝支付配置" name="alipay">
      <alipayTemplates></alipayTemplates>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
  import alipayTemplates from './payment/alipay'
  import wxpayTemplates from './payment/wxpay'
  export default {
    components: {
      alipayTemplates,
      wxpayTemplates
    },
    data () {
      return {
        activeName: 'wxpay',
      }
    },
    methods: {
      handleClick (tab, event) {
        if (this.activeName === "wxpay") {
        } else if (this.activeName === "alipay") {
        }
      }
    },
    mounted() {
      if('undefined' != typeof(this.$route.query.activeName)) {
        this.activeName = this.$route.query.activeName
      }
    }
  }

</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 10px;
  .frm-tips {
    color: #FF0000;
  }
}
</style>



// WEBPACK FOOTER //
// payment.vue?15ec87fd